import {
  PageType,
  type ReportPageConfig,
} from '../../components/PageConfigProvider/types';
import { PlotFilterType } from '../../components/PageConfigProvider/types/item';
import { FilterId } from '../../filters/types/filters';
import { buildReportPages } from './report-page-builder';

export const reportCompanyOverview: ReportPageConfig = (() => {
  const { items, grid } = buildReportPages(
    'company-overview',
    [
      [
        {
          id: '8dfcbe26-60bd-4988-93b0-54684d6cf15c',
          title: '',
          position: { x: 1, y: 10, width: 48, height: 8 },
          plot: {
            chartType: 'text',
            textHtml:
              '<h1 class="RichTextEditor_heading1__aGEIE" dir="ltr"><span style="white-space: pre-wrap;">Company Overview</span></h1><p dir="ltr"><span style="white-space: pre-wrap;">Overview of selected Company</span></p>',
          },
        },
      ],
      [
        {
          id: '23d7f90e-bb8e-430c-8240-b862cd2fefdf',
          title: '',
          position: { x: 1, width: 48, height: 15 },
          plot: {
            chartType: 'text',
            textHtml:
              '<h2 class="RichTextEditor_heading2__GzKPW" dir="ltr"><span style="white-space: pre-wrap;">About</span></h2><p dir="ltr"><span style="white-space: pre-wrap;">Oliver Wyman is a global leader in management consulting. With offices in more than 70 cities across 30 countries, Oliver Wyman combines deep industry knowledge with specialized expertise in strategy, operations, risk management, and organization transformation. The firm has more than 5,000 professionals around the world who work with clients to optimize their business, improve their operations and risk profile, and accelerate their organizational performance to seize the most attractive opportunities. Oliver Wyman is a business of Marsh McLennan [NYSE: MMC].</span></p><p><br></p>',
          },
        },
        {
          id: 'c90b3ac8-3332-4108-8a9e-94fe334d98f8',
          title: '',
          position: { x: 1, y: 35, width: 48, height: 8 },
          plot: {
            chartType: 'text',
            textHtml:
              '<h2 class="RichTextEditor_heading2__GzKPW" dir="ltr"><span style="white-space: pre-wrap;">Employee Headcount</span></h2><p dir="ltr"><span style="white-space: pre-wrap;">The company\'s workforce has grown steadily from about 13,000 employees in 2008 to nearly 20,000 in 2025, reflecting sustained global expansion. The majority of employees are based in Southern and Central America, with smaller presences across Europe, North America, Africa, and Asia.</span></p>',
          },
        },
      ],
      [
        {
          id: 'e9753e20-c65f-4981-a191-ac5f3ee5ac27',
          title: '',
          position: { x: 1, y: 8, width: 23, height: 19 },
          plot: {
            chartType: 'line',
            defaultMetricOptions: ['headcount'],
          },
        },
        {
          id: 'b2a9c0d1-3ded-483d-bfe8-44bb5a919fd4',
          title: 'Headcount by Geography',
          position: { x: 25, y: 8, width: 22, height: 19 },
          plot: {
            chartType: 'bar',
            sort: 'DESC',
            plotFilters: [
              {
                type: PlotFilterType.TOP_N,
                value: 10,
              },
            ],
            dimensionSource: 'geography',
            defaultMetricOptions: ['headcount'],
          },
        },
        {
          id: 'c3d0fa2a-f1a6-4c5e-8154-421d619437da',
          title: '',
          position: { x: 1, y: 35, width: 46, height: 14 },
          plot: {
            chartType: 'text',
            textHtml:
              '<h2 class="RichTextEditor_heading2__GzKPW" dir="ltr"><span style="white-space: pre-wrap;">Compensation</span></h2><p dir="ltr" style="text-align: start;"><span style="white-space: pre-wrap;">Compensation benchmarking allows employers to assess the competitiveness of their compensation package relative to those of its peers.</span></p><p dir="ltr" style="text-align: start;"><span style="white-space: pre-wrap;">While comparing salaries between employees at a company and its peer group as a whole provides a high-level view of where a company\'s compensation package stands, Revelio Labs\' rich workforce data allows for a more detailed company-level comparison as well. This enables organizations to determine which specific competitors they could recruit talent from, which they might be in danger of losing talent to, and how they can set compensation to match or exceed certain companies.</span></p><p dir="ltr" style="text-align: start;"><span style="white-space: pre-wrap;">Here, we compare [Company] salaries to those of its fifteen closest competitors. Companies paying lower salaries than their peers may benefit from strategically considering their compensation packages if they seek to increase employee retention and satisfaction.</span></p>',
          },
        },
      ],
      [
        {
          id: '0d67e8fa-17c0-42e5-8280-a61bd409c13d',
          title: 'Distribution',
          position: { x: 2, y: 13, width: 22, height: 19 },
          plot: {
            chartType: 'distribution',
            defaultMetricOptions: ['base_salary'],
            distributionCutoffLower: 1,
            distributionCutoffUpper: 99,
          },
        },
        {
          id: '5e8f9ab6-3d92-47a1-a90d-968c1a0f715b',
          title: 'Role',
          position: { x: 26, y: 13, width: 21, height: 9 },
          plot: {
            chartType: 'box',
            secondaryDimension: 'role',
            plotFilters: [
              {
                type: PlotFilterType.TOP_N,
                value: 8,
              },
            ],
            defaultMetricOptions: ['base_salary'],
          },
        },
        {
          id: '6ad542c0-d9ad-4c7a-8ad5-f6e5aefa55fe',
          title: 'Geography',
          position: { x: 26, y: 22, width: 21, height: 10 },
          plot: {
            chartType: 'box',
            secondaryDimension: 'geography',
            plotFilters: [
              {
                type: PlotFilterType.TOP_N,
                value: 10,
              },
            ],
            defaultMetricOptions: ['base_salary'],
          },
        },
        {
          id: '6efd8441-7c1e-4e5e-a8fb-fb7b33627c52',
          title: '',
          position: { x: 1, y: 35, width: 48, height: 11 },
          plot: {
            chartType: 'text',
            textHtml:
              '<h2 class="RichTextEditor_heading2__GzKPW" dir="ltr"><span style="white-space: pre-wrap;">Sentiment</span></h2><p dir="ltr"><span style="white-space: pre-wrap;">Understanding employee sentiment within an organization plays a critical role in analyzing company culture and overall workforce satisfaction, offering valuable insights for talent management, employee engagement strategies, productivity improvements, and retention efforts. Monitoring sentiment trends helps to identify areas of concern, gauge the effectiveness of leadership, and foster a positive work environment, ultimately contributing to better business outcomes and a more resilient workforce.</span></p>',
          },
        },
      ],
      [
        {
          id: 'd9a5476e-8471-4286-a8f1-24de45c2e318',
          title: 'Sentiment',
          position: { x: 2, y: 10, width: 24, height: 21 },
          plot: {
            chartType: 'diverging-bar',
            defaultMetricOptions: ['sentiment_top_bottom'],
          },
        },
        {
          id: '06fdd1d8-da75-4e02-bbc9-f1ae3a7c6516',
          title: '',
          position: { x: 28, y: 12, width: 19, height: 19 },
          plot: {
            chartType: 'text',
            textHtml:
              '<p dir="ltr"><span style="white-space: pre-wrap;">In addition to numerical ratings, we also analyze sentiment from the raw text of reviews. Using Natural Language Processing (NLP), we assess employee sentiment on specific topics, such as management and diversity. The resulting sentiment scores are standardized as z-scores, measured relative to a company\u2019s comparison set of source and destination companies based on talent flow. These standardized scores offer valuable insights into the factors that drive employees to join or leave a company.</span></p>',
            textVAlign: 'center',
          },
        },
      ],
    ],
    0
  );

  return {
    type: PageType.REPORT,
    id: 'report-company-overview',
    name: 'Overview',
    owner: { id: 'revelio-labs', username: 'revelio-labs' },
    tabs: [
      {
        id: 'default',
        label: 'Default',
        isActive: true,
        tabContent: {
          id: 'company-overview',
          items,
          grid,
          primaryFilter: {
            id: FilterId.COMPANY,
          },
          reportParameters: [
            {
              parameterId: 'company-overview-parameter',
              filterId: FilterId.COMPANY,
              isPrimary: true,
              name: 'Company',
            },
          ],
          secondaryFilters: [
            { id: FilterId.CONTINGENT_WORKERS },
            { id: FilterId.DATA_ADJUSTMENTS },
            { id: FilterId.EDUCATION },
            { id: FilterId.ETHNICITY },
            { id: FilterId.GENDER },
            { id: FilterId.KEYWORDS },
            { id: FilterId.ROLE },
            { id: FilterId.SENIORITY },
            { id: FilterId.CUSTOM_SKILL },
            { id: FilterId.TITLE },
          ],
        },
      },
    ],
  };
})();
